// src/modules/Elements/GameScreens.tsx
import styled from '@emotion/styled';
import { typography } from '~/modules/Elements/cssMixins';
import styles, { colorSets } from '~/modules/GameEngine/Drawing/styles';

export const GameScreens = styled.div`
  :root {
    --player-blue-text: ${colorSets.blue.text};
    --player-blue-stroke: ${colorSets.blue.stroke};
    --player-blue-star-fill: ${colorSets.blue.star.fill};
    --player-blue-star-stroke: ${colorSets.blue.star.stroke};
    --player-blue-perfect-fill: ${colorSets.blue.perfect.fill};
    --player-blue-perfect-stroke: ${colorSets.blue.perfect.stroke};
    --player-blue-starPerfect-fill: ${colorSets.blue.starPerfect.fill};
    --player-blue-starPerfect-stroke: ${colorSets.blue.starPerfect.stroke};
    --player-blue-hit-fill: ${colorSets.blue.hit.fill};
    --player-blue-hit-stroke: ${colorSets.blue.hit.stroke};
    --player-blue-miss-fill: ${colorSets.blue.miss.fill};
    --player-blue-miss-stroke: ${colorSets.blue.miss.stroke};
  }

  /* Base: no hacemos hacks de html font-size aquí */
  /* Tipografía fluida: evita monstruos en móvil y mantiene presencia en desktop */

  h1 {
    ${typography};
    margin: 0;
    text-align: center;
    color: ${styles.colors.text.active};
    line-height: 1.05;

    /* Antes: 4rem fijo. Ahora: fluido */
    font-size: clamp(2.4rem, 4.5vw, 5.4rem);
    letter-spacing: 0.02em;
  }

  h2 {
    ${typography};
    margin: 0;
    line-height: 1.1;
    font-size: clamp(1.8rem, 2.6vw, 3.2rem);
  }

  h3 {
    ${typography};
    margin: 0;
    line-height: 1.12;
    font-size: clamp(1.5rem, 2.2vw, 2.8rem);

    strong {
      color: ${styles.colors.text.active};
    }
  }

  h4 {
    ${typography};
    margin: 0;
    line-height: 1.18;
    font-size: clamp(1.15rem, 1.6vw, 2.2rem);
  }

  h5 {
    ${typography};
    margin: 0;
    line-height: 1.35;
    font-size: clamp(1.05rem, 1.2vw, 1.6rem);
  }

  h6 {
    ${typography};
    margin: 0;
    line-height: 1.35;
    font-size: clamp(0.95rem, 1.1vw, 1.3rem);
  }

  hr {
    margin: 0.5rem 1rem;
    opacity: 0.25;
  }

  h1,
  h2,
  h3,
  h4,
  h5 {
    button {
      ${typography};
      background: none;
      padding: 0;
      margin: 0;
      border: none;
      font-size: inherit;
      color: ${styles.colors.text.active};
      text-decoration: underline;
      cursor: pointer;
    }

    svg {
      font-size: 0.8em;
    }
  }

  strong {
    color: ${styles.colors.text.active};
  }
`;
